import React from 'react';
import ReactDOM from 'react-dom';
import './includes/bootstrap'; //Achivo de Bootstrap integrado jQuery y Popper
import App from '../src/components/App';


ReactDOM.render(<App/>, document.getElementById('app'));


